import { render, staticRenderFns } from "./FlagCard.vue?vue&type=template&id=66eef635&scoped=true&"
import script from "./FlagCard.vue?vue&type=script&lang=js&"
export * from "./FlagCard.vue?vue&type=script&lang=js&"
import style0 from "./FlagCard.vue?vue&type=style&index=0&id=66eef635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eef635",
  null
  
)

export default component.exports